import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { getSsoLoginOverride } from '../misc/login-routing';
import { FeaturesService } from '../services/features.service';

export const ssoLoginGuard: CanMatchFn = () => {
  const override = getSsoLoginOverride(inject(Router));
  return override ?? inject(FeaturesService).getFeatureValueAsync('bjornIdLogin');
};
